import React from 'react'
import { useCallback, useMemo, useState } from 'react'
import noop from 'lodash/noop'
import { ReactFCC } from '@/types/react'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

interface PayItForwardCheckoutState {
  isPayItForwardComplete: boolean
  onComplete: () => void
  isSubscription: boolean
}

const PayItForwardCheckoutContext = React.createContext<PayItForwardCheckoutState>({
  isPayItForwardComplete: false,
  onComplete: noop,
  isSubscription: false,
})

export const PayItForwardCheckoutProvider: ReactFCC = ({ children }) => {
  const [isPayItForwardComplete, setPayItForwardComplete] = useState(false)
  const { query } = useSafeRouter()

  const isSubscription = !!query?.subscribe
  const onComplete = useCallback(() => {
    setPayItForwardComplete(true)
  }, [setPayItForwardComplete])

  const value = useMemo(
    () => ({
      isPayItForwardComplete,
      onComplete,
      isSubscription,
    }),
    [isPayItForwardComplete, onComplete, isSubscription],
  )

  return <PayItForwardCheckoutContext.Provider value={value}>{children}</PayItForwardCheckoutContext.Provider>
}

export const usePayItForwardState = (): PayItForwardCheckoutState => {
  return React.useContext(PayItForwardCheckoutContext)
}
